module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-16-79670dc8536410f6622fb9efe5edcf4b.jpg";